import { Consommation } from '../../../models/rt2012/consommation';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export abstract class AbstractConsommationEnergie {

  protected locale: string;

  protected consommations: Consommation[];

  protected fromDate: Date;

  protected toDate: Date;

  constructor(locale: string, consommations: Consommation[], fromDate: NgbDate, toDate: NgbDate) {
    this.locale = locale;
    this.consommations = consommations;
    this.fromDate = new Date(fromDate.year, fromDate.month - 1, fromDate.day);
    this.toDate = new Date(toDate.year, toDate.month - 1, toDate.day);
  }
}
